<template>
  <v-container fluid>
    <p class="text-h4 text--primary">Skills</p>
    <v-divider class="my-5"></v-divider>

    <p class="text-h5 ml-6 text-uppercase">Language</p>
    <Lang />
    <v-divider class="my-8"></v-divider>

    <p class="text-h5 ml-6 text-uppercase">FrameWork</p>
    <FrameWork />
    <v-divider class="my-8"></v-divider>

    <p class="text-h5 ml-6 text-uppercase">Others</p>
    <Others />
    <v-divider class="my-8"></v-divider>

    <p class="text-h5 ml-6 text-uppercase">Extra</p>
    <Extra />
  </v-container>
</template>

<script>
import Extra from "@/components/Skills/Extra";
import FrameWork from "@/components/Skills/FrameWork";
import Lang from "@/components/Skills/Lang";
import Others from "@/components/Skills/Others";

export default {
  components: {
    Extra,
    FrameWork,
    Lang,
    Others,
  },
};
</script>
